import { useContext } from "react";
import { AppContext, AppData } from "../context/app-data.context";

export const useAppContext = (): {
  appData: AppData;
  setAppData: React.Dispatch<React.SetStateAction<AppData>>;
} => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error("Hook must be used with in AppContextProvider");
  }
  return context;
};
